import { Switch, useRouteMatch } from 'react-router-dom';
import { CampaignTeamDrawerForm } from 'assets/js/pages/campaign-settings/campaign-teams/CampaignTeamDrawerForm';
import { CampaignTeams } from 'assets/js/pages/campaign-settings/campaign-teams/CampaignTeams';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';

const CampaignTeamsRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute
                path={[`${match.path}/:teamId(\\d+)`, `${match.path}/new`]}
                component={CampaignTeamDrawerForm}
            />
            <Switch>
                <Route path={match.path} component={CampaignTeams} />
            </Switch>
        </>
    );
};

export { CampaignTeamsRouter };
